import { gql } from '@apollo/client'

export const GET_CATEGORY_SLUGS_QUERY = gql`
  query getCategorySlugs($filter: faq_categories_filter) {
    faqCategories: faq_categories(filter: $filter) {
      slug
    }
  }
`
